import { createContext, ReactNode, useState } from 'react';

export enum HomeSectionsRefreshAction {
  ALL = 'ALL',
  SALES_ORDERS = 'SALES_ORDERS',
  DEVICES = 'DEVICES',
  SOFTWARE = 'SOFTWARE',
  WORK_ORDERS = 'WORK_ORDERS',
}

export type HomeSectionsContextProps = {
  refreshAction?: {
    action: HomeSectionsRefreshAction;
    timestamp: number;
  };
  setRefreshAction: (action: HomeSectionsRefreshAction) => void;
};

export const HomeSectionsContext = createContext<HomeSectionsContextProps>(
  {} as HomeSectionsContextProps
);

export type HomeSectionsProviderProps = {
  children: ReactNode;
};

export const HomeSectionsProvider = ({
  children,
}: HomeSectionsProviderProps) => {
  const [refreshAction, setAction] = useState<{
    action: HomeSectionsRefreshAction;
    timestamp: number;
  }>();

  const setRefreshAction = (action: HomeSectionsRefreshAction) => {
    setAction({ action, timestamp: Date.now() });
  };

  return (
    <HomeSectionsContext.Provider value={{ setRefreshAction, refreshAction }}>
      {children}
    </HomeSectionsContext.Provider>
  );
};
